import "./Academy.css";
import AcadmicCard from "./Card/AcadmicCard";
import bis from '../asset/icons/bis.jpeg'
import iti from '../asset/icons/iti-logo.png'
import nti from '../asset/icons/nti.png'
import g from '../asset/icons/g.png'
import uni from '../asset/icons/univeristy-michigan.jpg'
function Academy() {
  return (
    <div className="AcadmicCard">
      <AcadmicCard
        From="Helwan University, Cairo, Egypt"
        CourseName="Faculty of commerce & business administration"
        Date="2015 - 2019"
        Img={bis}
      />
       <AcadmicCard
        From="Information Technology Institute (ITI)"
        CourseName="Frontend and
Cross platform mobile application Track"
        Date="Aug 2021 – Nov 2021"
        Credential='https://www.linkedin.com/in/hady-hesham-011084159/overlay/1635485554936/single-media-viewer/'
        Img={iti}
      />
      <AcadmicCard
        From="National telecommunications institute(NTI)"
        CourseName="Web development using angular and node JS"
        Date="Feb 2021 – March 2021"
        Credential='https://www.linkedin.com/in/hady-hesham-011084159/overlay/education/708968856/multiple-media-viewer/?treasuryMediaId=1635464616075'
        Img={nti}
      />
       <AcadmicCard
        From="University of Michigan - Coursera"
        CourseName="Web Design for Everybody Capstone"
        Date="Jun 2021"
        Credential='https://www.coursera.org/account/accomplishments/certificate/M7HALAXNPVQ3'
        Img={uni}
      />
         <AcadmicCard
        From="Google - Coursera"
        CourseName="Foundations of User Experience (UX) Design"
        Date="Mar 2022"
        Credential='https://www.coursera.org/account/accomplishments/certificate/CKHY72526HZF'
        Img={g}
      />
    </div>
  );
}

export default Academy;
